import { useEffect, useRef } from "react";
import { Pin, PinOff } from "lucide-react";

/**
 * Right-click context menu that lets the user pin/unpin any nav row.
 * Fixed-positioned at the mouse coordinates; closes on outside click or Esc.
 */
export default function SidebarContextMenu({ x, y, pinned, onToggle, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      role="menu"
      data-testid="sidebar-context-menu"
      className="fixed z-[100] min-w-[180px] rounded-lg border border-white/10 bg-[#0F1420]/95 backdrop-blur-xl shadow-2xl py-1"
      style={{ top: y, left: x }}
    >
      <button
        type="button"
        onClick={() => { onToggle(); onClose(); }}
        data-testid="sidebar-context-menu-toggle-pin"
        className="w-full flex items-center gap-2 px-3 py-2 text-sm text-slate-200 hover:bg-white/5 hover:text-white transition-colors"
      >
        {pinned ? <PinOff className="w-3.5 h-3.5 text-orange-400" /> : <Pin className="w-3.5 h-3.5 text-orange-400" />}
        {pinned ? "Unpin from sidebar" : "Pin to sidebar"}
      </button>
    </div>
  );
}
